import { useState } from 'react';
import Tooltip from '@mui/material/Tooltip';
import { Select, MenuItem, Box } from '@mui/material';
import { DayNightModeChangeHandler } from '../../../utils/DayNightModeChangeHandler';
import DayIcon from 'components/icons/DayIcon';
import NightIcon from 'components/icons/NightIcon';
import DayNightAutoIcon from 'components/icons/DayNightAutoIcon';

function DayNightModeButton({ camId }) {
    const [selectedValue, setSelectedValue] = useState('AUTO');
    const [isOpen, setIsOpen] = useState(false);

    const handleChange = (event) => {
        setSelectedValue(event.target.value);
        DayNightModeChangeHandler(camId, event.target.value);
    };

    let tooltipValue;

    switch (selectedValue) {
        case 'AUTO':
            tooltipValue = 'Automatic mode';
            break;
        case 'YES':
            tooltipValue = 'Day mode';
            break;
        case 'NO':
            tooltipValue = 'Night mode';
            break;

        default:
            tooltipValue = 'Automatic mode';
    }

    return (
        <Tooltip title={tooltipValue}>
            <Select
                onOpen={() => setIsOpen(true)}
                onClose={() => setIsOpen(false)}
                value={selectedValue}
                onChange={handleChange}
                sx={{
                    boxShadow: 'none',
                    '.MuiOutlinedInput-notchedOutline': { border: 0 },
                    '& .MuiOutlinedInput-notchedOutline': {
                        border: 'none',
                    },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        border: 'none',
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                        border: 'none',
                    },
                    '& .MuiSelect-select': {
                        paddingRight: '0 !important',
                        paddingLeft: 0,
                        paddingTop: 0,
                        paddingBottom: 0,
                    },

                    maxWidth: '25px',
                }}
                MenuProps={{
                    anchorOrigin: {
                        vertical: 'top',
                        horizontal: 'center',
                    },
                    transformOrigin: {
                        vertical: 'bottom',
                        horizontal: 'center',
                    },
                }}
                IconComponent={() => null}
            >
                <MenuItem value="AUTO">
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                        <DayNightAutoIcon isopen={isOpen.toString()} />
                        Automatic day-night mode
                    </Box>
                </MenuItem>
                <MenuItem value="YES">
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                        <DayIcon isopen={isOpen.toString()} /> Day mode
                    </Box>
                </MenuItem>
                <MenuItem value="NO">
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                        <NightIcon isopen={isOpen.toString()} />
                        Night mode
                    </Box>
                </MenuItem>
            </Select>
        </Tooltip>
    );
}

export default DayNightModeButton;
